import script from "./OfferCustomer.vue?vue&type=script&setup=true&lang=js"
export * from "./OfferCustomer.vue?vue&type=script&setup=true&lang=js"

import "./OfferCustomer.vue?vue&type=style&index=0&id=d3082064&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3082064"]])

export default __exports__